import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { normalizeTheme } from './Core/Config';
import { fetchCurrentUser } from './Core/Auth';
import AppLoading from './Utilites/AppLoading';
import { preventMediaAction } from './Utilites/MediaProtection';
import './Utilites/MediaProtection.css';


import Home from './Home';
import Quiz from './Quiz';

const getStoredTheme = () => {
    const savedTheme = localStorage.getItem('quizTheme');
    const normalizedTheme = normalizeTheme(savedTheme);

    if (savedTheme && savedTheme !== normalizedTheme) {
        localStorage.setItem('quizTheme', normalizedTheme);
    }

    return normalizedTheme;
};

function App() {
    const [auth, setAuth] = useState(null);
    const [authLoading, setAuthLoading] = useState(true);
    const [theme] = useState(getStoredTheme);

    useEffect(() => {
        let active = true;

        const loadAuth = async () => {
            const currentAuth = await fetchCurrentUser();

            if (!active) {
                return;
            }

            setAuth(currentAuth);
            setAuthLoading(false);
        };

        loadAuth();

        return () => {
            active = false;
        };
    }, []);

/*
            <nav>
                <NavLink to="/">
                    {({ isActive }) => ( isActive ? <strong>Ăšvod</strong> : 'Ăšvod' )}
                </NavLink>
                <NavLink to="/quiz">
                    {({ isActive }) => ( isActive ? <strong>KvĂ­z</strong> : 'KvĂ­z' )}
                </NavLink>                      
            </nav>
*/
  if (authLoading) {
    return (
      <main id="quiz-wrapper" data-theme={theme}>
        <AppLoading>Ověřuji aplikaci...</AppLoading>
      </main>
    );
  }

  return (
    <Router>
        <main id="quiz-wrapper" data-theme={theme}
            onContextMenuCapture={preventMediaAction} onDragStartCapture={preventMediaAction}>
            <>
                <Routes>
                    <Route path="/" element={<Home auth={auth} />} />
                    <Route path="/quiz/*" element={<Quiz auth={auth} />} />          
                </Routes> 
            </> 
            <div id="breakpoints" className="hidden"></div>
        </main>
    </Router>
  );
}

export default App;


